import React, { useEffect, useState } from 'react';

import * as rsuite from 'rsuite'
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useNavigate, useParams } from "react-router-dom";
import * as General from '../../General/General';
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "rsuite/dist/rsuite-rtl.min.css";
import { MdOutlineMenu } from "react-icons/md";
import SharedTopic from '../../Components/Frame/SharedTopic';
import { Interweave } from 'interweave';
import { GiServerRack } from 'react-icons/gi';
const TopicHome = () => {


    //#region Constants
    let navigate = useNavigate();

    const [Result, setResult] = useState([]);
    const [PId, setPId] = useState(General.GuidEmpty());
    //#endregion Constants
    //#region methods 




    const Bind = () => {
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/Project/GetAll",
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY

            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setResult(res.data);
                console.dir(res.data);
            })

            .catch(error => {

            })
    }

    useEffect(() => {

        Bind();
    }, [])

    useEffect(() => {
        if (PId != General.GuidEmpty()) {
            navigate("/Show/" + PId + "/" + General.GuidEmpty(), { replace: true });
        }
    }, [PId])

    //#endregion methods
    return (
        <SharedTopic>
            <rsuite.Grid fluid className='h100vh'>

                <rsuite.Row className='mt-5'>
                    {
                        Result.map(item =>
                            <rsuite.Col xs={24} md={12}>
                                <rsuite.Panel onClick={() => setPId(item.id)} className='Hand mb-3 bg-light center'>
                                    <h3>
                                        {item.title}
                                    </h3>
                                </rsuite.Panel>
                            </rsuite.Col>
                        )
                    }

                </rsuite.Row>

            </rsuite.Grid>
        </SharedTopic>
    )
}

export default TopicHome;